import { render, staticRenderFns } from "./ConsultNoteCard.vue?vue&type=template&id=b2f5ebb4&scoped=true"
import script from "./ConsultNoteCard.vue?vue&type=script&lang=js"
export * from "./ConsultNoteCard.vue?vue&type=script&lang=js"
import style0 from "./ConsultNoteCard.vue?vue&type=style&index=0&id=b2f5ebb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f5ebb4",
  null
  
)

export default component.exports